import VoucherState from 'Voucher/intefaces/state';

const voucherInitialState: VoucherState = {
  voucherItems: null,
};

export default voucherInitialState;
